module.exports = {
  urlWifiAuth: process.env.VUE_APP_WIFI_AUTH_URL,
};
